import { render, staticRenderFns } from "./WangEditor.vue?vue&type=template&id=42f8ea9d&"
import script from "./WangEditor.vue?vue&type=script&lang=js&"
export * from "./WangEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports